<template>
    <div class="form-group cta-container">
		<!-- <router-link v-if="props.linkBackUrl" :to="props.linkBackUrl" class="btn btn-gray">{{ props.linkBackLabel }}</router-link>
		<router-link v-if="props.linkSkippUrl" :to="props.linkSkippUrl" class="btn btn-cta">{{ props.linkSkippLabel }}</router-link>
		<p v-if="props.information">
			Du har begärt att anna.andersson.org.se ska tecka avtal som (PUB)Avtalsansvarig
		</p>
		<router-link v-if="props.linkForwardUrl" :to="props.linkForwardUrl" class="btn btn-cta">{{ props.linkForwardLabel }}</router-link> -->
		<slot />
	</div>
</template>


<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
	name: 'CtaPanel'
})

</script>

<style lang="scss">
	.cta-container {
		display: flex;

		a {

			+ a {
				margin-left: auto;

				+ a {
					margin-left: 1rem;
				}
			}
		}
	}
</style>